import { render, staticRenderFns } from "./CnCoa.vue?vue&type=template&id=327e95a4&scoped=true&"
import script from "./CnCoa.vue?vue&type=script&lang=js&"
export * from "./CnCoa.vue?vue&type=script&lang=js&"
import style0 from "./CnCoa.vue?vue&type=style&index=0&id=327e95a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e95a4",
  null
  
)

export default component.exports